export const homePageText = {
    hero:{
        title: 'Our Philosophy ',
        body: 'We believe that each startup has a unique journey. Thus, we contribute to the startup journey by providing mentorship, advice, networking, experience transfer, and/or financial funding. Assuring startups benefit from a carefully crafted balance between financial ROI and social impact. For this purpose, UII collaborates with like-minded investors to expand our boutique investment approach. ',
    }
}